import "core-js/modules/es6.object.freeze";
// The owner side's look: Atlas, on the create-community wizard and the owner dashboard (#126 chose it, #182 built it on
// the design standard). Heide and Nachtkaart, the two other looks, were removed on 12 Oct 2026 (the user; a rollback is a
// git revert). The look's tokens are CSS (src/css/tokens/atlas.css, the class LOOK_CLASS); this file holds what the
// scripts need of it: the ground under the page, the web font, and the colours and the map the Leaflet maps draw with
// (they mirror atlas.css's --at-area-line and --at-shape-line).
export var LOOK_CLASS = 'at-look';
export var ATLAS = Object.freeze({
  id: 'atlas',
  lookClass: LOOK_CLASS,
  // the page's own ground colour (also under the page: a phone's keyboard showed the app's light ground below it)
  paper: '#F7F9F8',
  // its web font's stylesheet, self-hosted (#133: was Google Fonts, which saw every owner's visit): Archivo, variable
  // in width and weight, with its licence in that folder
  fontCss: '/statics/fonts/archivo/archivo.css',
  // the chosen area on every map: magenta, nothing in nature is magenta so it pops on any map (the mix tint, 9 Oct)
  areaLine: '#C2185B',
  // the areas' shapes in the previews (the phone rows, the dashboard): a deep forest green
  shapeLine: '#0B3D24',
  // the dots' rim on the first screen's map
  rim: '#FFFFFF',
  mapLayer: 'esri-topo'
}); // the fans' look: D6D (#239, its tokens src/css/tokens/fan.css on the class fan-look, #334): its paper under the page
// (it mirrors --fl-paper) and its web font, self-hosted (Albert Sans, with its licence in that folder). The fan pages
// wear it in #339 / #340; the app loader's Duin look already does

export var FAN = Object.freeze({
  id: 'fan',
  lookClass: 'fan-look',
  paper: '#EFE6D4',
  fontCss: '/statics/fonts/albert-sans/albert-sans.css'
}); // the look's font, as one stylesheet link in <head>; null takes it away. id: whose link it is (the pages in the look
// share one; the app's header has its own, #333, so a page leaving the look does not take the header's font away)

var FONT_LINK_ID = 'wz-fonts';
export var loadLookFonts = function loadLookFonts(look) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FONT_LINK_ID;
  var old = document.getElementById(id);

  if (!look || !look.fontCss) {
    if (old) old.remove();
    return;
  }

  var href = look.fontCss;
  if (old && old.getAttribute('href') === href) return;
  var link = old || document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = href;
  if (!old) document.head.appendChild(link);
}; // the ground under the page (html and body) in the look's paper, without the app theme's picture (glass: its
// gradient showed beside and under an old page's column, #338); null puts the app's back

export var setLookGround = function setLookGround(look) {
  var ground = look ? look.paper : '';
  var picture = look ? 'none' : '';
  document.documentElement.style.backgroundColor = ground;
  document.body.style.backgroundColor = ground;
  document.documentElement.style.backgroundImage = picture;
  document.body.style.backgroundImage = picture;
};